import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getOr } from 'lodash/fp';
import * as reportingActions from 'actions/pathBuilder/reporting';
import { hasReportingPermission } from 'selectors/pathBuilder';
import ReportingHeader from './Partials/ReportingHeader';
import ReportingBlockGroup from './Partials/ReportingBlockGroup';
import GroupFilter from './GroupFilter';
import Assignments from './Assignments';
import LearningLibrary from './LearningLibrary';
import Performance from './Performance';
import GradebookButton from './GradebookButton';
import AssignView from './AssignView';
import AncestorPaths from './AncestorPaths';

class Reporting extends PureComponent {
  constructor() {
    super();
    this.handleGroupChange = this.handleGroupChange.bind(this);
  }

  componentDidMount() {
    const { groupId } = this.props;
    if (groupId) {
      this.props.setGroup(groupId);
    }
    this.props.fetchData(groupId);
  }

  handleGroupChange(groupId) {
    this.props.setGroup(groupId);
    this.props.fetchData(groupId);
  }

  render() {
    const {
      groupId,
      loading,
      canViewGradebook,
      viewAssign,
      viewGroupFilter,
      viewLibraryStats,
      viewActivity,
      canViewAncestors,
    } = this.props;
    return (
      <div className="PathReporting mt-48">
        {viewAssign && <AssignView onAssign={() => window.location.reload()} />}
        <ReportingHeader>
          {viewGroupFilter && (
            <GroupFilter groupId={groupId} onChange={this.handleGroupChange} />
          )}
          {canViewGradebook && <GradebookButton />}
        </ReportingHeader>
        <ReportingBlockGroup>
          {viewActivity && <Assignments />}
          {viewLibraryStats && <LearningLibrary />}
          <Performance loading={loading} />
          {canViewAncestors && <AncestorPaths />}
        </ReportingBlockGroup>
      </div>
    );
  }
}

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  groupId: pathBuilder.reporting.groupId,
  loading: getOr(true, 'loading')(pathBuilder.reporting),
  canViewGradebook: hasReportingPermission(pathBuilder, 'viewGradebook'),
  viewAssign: hasReportingPermission(pathBuilder, 'viewAssign'),
  viewGroupFilter: hasReportingPermission(pathBuilder, 'viewGroupFilter'),
  viewLibraryStats: hasReportingPermission(pathBuilder, 'viewLibraryStats'),
  viewActivity: hasReportingPermission(pathBuilder, 'viewActivity'),
  canViewAncestors: hasReportingPermission(pathBuilder, 'viewAncestors'),
});

const mapDispatchToProps = {
  setGroup: reportingActions.setGroup,
  fetchData: reportingActions.fetchData,
};

export default connect(mapStateToProps, mapDispatchToProps)(Reporting);
